import { useTranslation } from 'react-i18next'
import { RadioOptionPicker } from '../../../../components/common/Form/RadioOptionPicker/RadioOptionPicker'
import { Option } from '../../../../components/common/Form/types'
import { DataTypeParam } from '@/hooks/useApi/useActiveManagementApi/types'

export const DataTypeSelect: React.FC<{
    value: DataTypeParam
    onChange: (type: DataTypeParam) => void
}> = (props) => {
    const { t } = useTranslation('translations')
    const { value, onChange } = props

    const options: Array<Option<DataTypeParam>> = [
        {
            value: 'demandAverage',
            label: t(
                'active_management.interval.report_settings.data_setup.dataType.demandAverage.label'
            ),
            subtitle: t(
                'active_management.interval.report_settings.data_setup.dataType.demandAverage.subtitle'
            ),
        },
        {
            value: 'demandMax',
            label: t(
                'active_management.interval.report_settings.data_setup.dataType.demandMax.label'
            ),
            subtitle: t(
                'active_management.interval.report_settings.data_setup.dataType.demandMax.subtitle'
            ),
        },
        {
            value: 'usage',
            label: t(
                'active_management.interval.report_settings.data_setup.dataType.usage.label'
            ),
            subtitle: t(
                'active_management.interval.report_settings.data_setup.dataType.usage.subtitle'
            ),
        },
    ]

    return (
        <RadioOptionPicker
            name="data-type"
            label={t(
                'active_management.interval.report_settings.data_setup.dataType.label'
            )}
            value={value}
            options={options}
            onChange={(newValue: string) => {
                onChange(newValue as DataTypeParam)
            }}
            renderLabel={(option) => (
                <div className="flex flex-col">
                    <div className="text-label-small text-regular">
                        {option.label}
                    </div>
                    {option.subtitle && (
                        <div className="text-body-small font-normal text-subtle">
                            {option.subtitle}
                        </div>
                    )}
                </div>
            )}
        />
    )
}
